import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Drawer from "./Components/Drawer/Drawer";
import RoutesConfig from "./Routes/RoutesConfig";
import GlobalLoading from "./Components/Generic/GlobalLoading";
import "./App.css";
import Config from "./config";
import EncryptionUtils from "./Utils/EncryptionUtils";
import { LicenseInfo } from "@mui/x-license";
import AppTopBar from "./Components/Generic/AppTopBar";
import { useTranslation } from "react-i18next";
import { clearListPageFilters } from "./Utils/listPageStateStorage";
import { startAppVersionCheck } from "./Utils/appVersionCheck";
import { clearSessionData } from "./Utils/sessionManager";

export default function App(props) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const { config } = props;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { i18n } = useTranslation();

  LicenseInfo.setLicenseKey(
    "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
  );

  useEffect(() => startAppVersionCheck(), []);

  useEffect(() => {
    const storedUser = JSON.parse(EncryptionUtils.getDecryptedData("user"));
    if (storedUser) {
      setUser(storedUser);
      setIsAuthenticated(true);
      setDrawerOpen(true);

      const savedLanguage = localStorage.getItem("language");
      if (savedLanguage) {
        i18n.changeLanguage(savedLanguage);
      } else if (storedUser.idLanguage) {
        const userLanguage = storedUser.idLanguage;
        const idiomaBase = userLanguage === 1 ? "es" : "en";
        localStorage.setItem("language", idiomaBase);
        i18n.changeLanguage(idiomaBase);
      }
    }
  }, []);

  useEffect(() => {
    const userLogin =
      user ?? JSON.parse(EncryptionUtils.getDecryptedData("user") || "null");

    if (userLogin != null && userLogin.user != null) {
      const userPermissions = userLogin?.user.permisosWebUsuarios || [];
      const itemsPermissions = userPermissions.filter(
        (permiso) => permiso?.estatus
      );
      setPermissions(itemsPermissions);
    } else if (user != null) {
      handleLogout();
    }
  }, [user]);

  const handleLogin = (username) => {
    clearListPageFilters();
    setUser(username);
    setIsAuthenticated(true);
    setDrawerOpen(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    clearSessionData();
    setDrawerOpen(false);
  };

  const handleLanguageChange = (updatedUserData) => {
    setUser(updatedUserData);
    const userPermissions = updatedUserData?.user.permisosWebUsuarios || [];
    const itemsPermissions = userPermissions.filter(
      (permiso) => permiso?.estatus
    );
    setPermissions(itemsPermissions);
  };

  return (
    <Router basename={Config.basename}>
      <GlobalLoading />
      <div
        className="app-container"
        style={{
          backgroundColor: user ? "#F0F2F5" : "#07468E",
        }}
      >
        {user && (
          <Drawer
            user={user}
            drawerOpen={drawerOpen}
            config={config}
            permissions={permissions}
          />
        )}
        <div className={user ? "app-main" : "content-container"}>
          {user && (
            <AppTopBar
              config={config}
              onLogout={handleLogout}
              onLanguageChange={handleLanguageChange}
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpen}
            />
          )}
          <div
            className={`content-container${user ? " content-container--authenticated" : ""}`}
          >
            <RoutesConfig
              user={user}
              handleLogin={handleLogin}
              permissions={permissions}
              config={config}
              isAuthenticated={isAuthenticated}
            />
          </div>
        </div>
      </div>
    </Router>
  );
}
